/**
 * What an extra subaccount event shows in the activity logs: the count change, why or
 * how it happened, and which subaccounts a removal locked. Empty values are left out.
 */
export function extraSubaccountBadges(md: Record<string, unknown>): Array<{ label: string; value: string }> {
  const badges: Array<{ label: string; value: string }> = [];
  const add = (label: string, value: unknown) => {
    if (value) badges.push({ label, value: String(value) });
  };
  if (md.extrasBefore != null && md.extrasAfter != null) add('Extras', `${md.extrasBefore} → ${md.extrasAfter}`);
  add('Reason', md.reason);
  add('Via', md.via);
  add('Error', md.message);
  // A removal Stripe couldn't confirm: it may not have gone through there.
  if (md.unconfirmed) add('Stripe', 'Unconfirmed');
  if (Array.isArray(md.lockedSubaccountNames) && md.lockedSubaccountNames.length > 0) {
    add('Locked', md.lockedSubaccountNames.join(', '));
  }
  return badges;
}
